import { FC } from "react";
import { Path, Rect, Svg } from "react-native-svg";

import { tSvgProps } from "../types";

const PdPencilLine: FC<tSvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 17 17" fill="none" {...props}>
      <Path
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        focusable={false}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2213 5.73029C15.7565 5.33768 15.8721 4.58545 15.4794 4.0503L14.5315 2.75837C14.1389 2.22322 13.3868 2.10767 12.8516 2.50029L2.19255 10.3201C2.14741 10.3533 2.10971 10.3956 2.08188 10.4442L0.122667 13.8691C0.0441645 14.0065 0.0537443 14.1773 0.147455 14.3049C0.241148 14.4326 0.401072 14.4931 0.555824 14.4594L4.41088 13.6187C4.46564 13.6068 4.51727 13.5834 4.56239 13.5503L15.2213 5.73029ZM14.8334 4.52426C14.9643 4.7026 14.9257 4.95328 14.7474 5.08426L4.15716 12.8538L1.26599 13.4843L2.73524 10.9159L13.3259 3.14601C13.5042 3.01518 13.7549 3.05369 13.8857 3.23203L14.8334 4.52426Z"
        fill="currentColor"
      />
      <Path
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        focusable={false}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1507 4.24512L13.0463 6.82907L13.6924 6.3551L11.7966 3.77113L11.1507 4.24512Z"
        fill="currentColor"
      />
      <Rect // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        focusable={false}
        y="15.7734"
        width="16"
        height="0.75"
        rx="0.375"
        fill="currentColor"
      />
    </Svg>
  );
};

export default PdPencilLine;
